<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <span>基础数据</span>
      </div>
      <el-form ref="queryForm" :model="queryParams" :inline="true">
        <el-form-item label="开始周" prop="startDate">
          <el-date-picker
            v-model="queryParams.startDate"
            type="week"
            placeholder="选择周"
            format="WW"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="结束周" prop="startDate">
          <el-date-picker
            v-model="queryParams.endDate"
            type="week"
            placeholder="选择周"
            format="WW"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          <el-button :loading="loading" icon="el-icon-refresh" size="mini" @click="exportData">导出</el-button>
        </el-form-item>
      </el-form>
      <weekAct ref="weekAct" />
      <weekPay ref="weekPay" />
      <weekAvg ref="weekAvg" />
    </el-card>
    <el-card>
      <div slot="header" class="clearfix">
        <span>周数据分布走势</span>
      </div>
      <el-row :gutter="12">
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <chart ref="reg" />
        </el-col>
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <chart ref="pay" />
        </el-col>
      </el-row>
      <el-row :gutter="12">
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <chart ref="price" />
        </el-col>
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <chart ref="arrppu" />
        </el-col>
      </el-row>
    </el-card>
    <el-card>
      <div slot="header" class="clearfix">
        <span>重点国家数据</span>
      </div>
      <el-row :gutter="12">
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <country :typ="1" />
        </el-col>
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <country :typ="2" />
        </el-col>
      </el-row>
      <el-row :gutter="12">
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <country :typ="3" />
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { getWeekData } from '@/api/config/week-stat'
import weekAct from '@/views/config/week/components/act.vue'
import weekPay from '@/views/config/week/components/pay.vue'
import weekAvg from '@/views/config/week/components/avg.vue'
import chart from '@/views/config/week/components/echart.vue'
import country from '@/views/config/week/components/country.vue'

export default {
  name: 'WeekStat',
  components: {
    weekAct,
    weekPay,
    chart,
    country,
    weekAvg
  },
  data() {
    return {
      loading: false,
      queryParams: {
        startDate: '',
        endDate: '',
        type: 0
      }
    }
  },
  created() {
    this.getTable()
  },
  methods: {
    exportData() {
      this.loading = true
      this.queryParams.type = -1
      this.getTable()
    },
    handleQuery() {
      this.queryParams.type = 0
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始周')
        return
      }

      if (!this.queryParams.endDate) {
        this.msgError('请选择结束周')
        return
      }

      this.getTable()
    },
    getTable() {
      getWeekData(this.queryParams).then(res => {
        if (this.queryParams.type === -1) {
          if (res.code === 200) {
            this.loading = false
            window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
            return
          }
        }
        this.queryParams.startDate = res.data.req.startDate
        this.queryParams.endDate = res.data.req.endDate
        this.$refs.reg.refresh(1, res.data.act, '周新增用户')
        this.$refs.pay.refresh(2, res.data.pay, '收入与花费')
        this.$refs.price.refresh(3, res.data.pay, '日均付费率')
        this.$refs.arrppu.refresh(4, res.data.pay, '日均ARPPU')
        this.$refs.weekAct.init(res.data.act)
        this.$refs.weekPay.init(res.data.pay)
        this.$refs.weekAvg.init(res.data.avg)
        for (const i in res.data.act) {
          const val = res.data.act[i]
          for (const k in res.data.pay) {
            const pay = res.data.pay[k]
            if (val.week === pay.week) {
              res.data.pay[k].ad = val.ad_price
            }
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
